export interface ILocalizedDate {
  setLocale: (locale: string) => ILocalizedDateFormatter;
}

export interface ILocalizedDateFormatter {
  toFormat: (format: string) => string;
}

export interface ILocalizedDuration {
  toFormat: (format: string) => string;
}

export const formatDate = (date: ILocalizedDate, locale: string, format: string): string => {
  return date.setLocale(locale).toFormat(format);
};

export const formatDuration = (duration: ILocalizedDuration, format: string): string => {
  return duration.toFormat(format);
};
